import React from "react";
import { connect } from "react-redux";
import Carrousel from "../carrusel/carrusel.cmpt";

const mapState = (state) => {
	return {
		loading: state.global.loading
	};
};

const mapDispatch = (dispatch) => {
	return {
		siguientePaso: (iPaso) => {
			dispatch({ "type": "OLVIDE_PASO_SIGUIENTE" });
		}
	};
};

class Footer extends React.Component {
	render() {
		return (
			<div>
			<Carrousel />
				<div className="blue-wrap-footer mt-50">
					<div className="container">
						<ul className="box">
							<li className="list">
								<ul>
									<li><img src={ require("../img/logo-gnp.svg") } style={{background: "#FFFFFF"}} /></li>
								</ul>
							</li>
							<li className="list">
								<ul>
									<li><span>PERSONAS</span></li>
									<li><a>Seguro de Auto</a></li>
									<li><a>Gastos médicos</a></li>
									<li><a>Vida y educación</a></li>
									<li><a>Retiro y ahorro</a></li>
									<li><a>Hogar</a></li>
									<li><a>GNP Driving School</a></li>
								</ul>
							</li>
							<li className="list">
								<ul>
									<li><span>EMPRESAS</span></li>
									<li><a>PyMEs</a></li>
									<li><a>Corporativos</a></li>
								</ul>
							</li>
							<li className="list">
								<ul>
									<li><span>SECTOR PÚBLICO</span></li>
									<li><a>Seguro de Auto</a></li>
									<li><a>Gastos médicos</a></li>
									<li><a>Vida y educación</a></li>
									<li><a>Retiro y ahorro</a></li>
									<li><a>Hogar</a></li>
									<li><a>GNP Driving School</a></li>
								</ul>
							</li>
							<li className="list">
								<ul>
									<li><span>SOY CLIENTE</span></li>
									<li><a>PyMEs</a></li>
									<li><a>Corporativos</a></li>
								</ul>
							</li>
							<li className="list">
								<ul>
									<li><span>GNP SEGUROS</span></li>
									<li><a>Seguro de Auto</a></li>
									<li><a>Gastos médicos</a></li>
									<li><a>Vida y educación</a></li>
									<li><a>Retiro y ahorro</a></li>
									<li><a>Hogar</a></li>
									<li><a>GNP Driving School</a></li>
								</ul>
							</li>
						</ul>
					</div>
					<p>&nbsp;</p>
				</div>
				<div className="orange-wrap-footer">
					<div className="container">
						<ul className="blue-menu clearfix">
							<li><a>Colaboradores</a></li>
							<li><a>Información Financiera</a></li>
							<li><a>Buró de Entidades Financieras</a></li>
							<li><a>Glosario</a></li>
							<li><a>Aviso de privacidad</a></li>
							<li><a>Mapa de sitio</a></li>
						</ul>
					</div>
				</div>

				<div className="footer-wrap">
					<div className="footer-left">
						<div className="footer-logos"><img src={ require("../img/logo-1.png") }/></div>
						<div className="footer-logos"><img src={ require("../img/logo-2.png") }/></div>
						<div className="footer-logos"><img src={ require("../img/logo-3.png") }/></div>
						<div className="footer-logos"><img src={ require("../img/logo-4.png") }/></div>
						<p>Copyright© 2015 Grupo Nacional Provincial S.A.B. </p>
					</div>
					<div className="footer-right">
						<div className="articulos-interes">Artículos de interés</div>
						<div className="social-icon"><a href="http://es-es.facebook.com/pages/GNP-SEGUROS-OFICIAL/387796290649"><img src={ require("../img/facebook-2.png") }/></a></div>
						<div className="social-icon"><a href="http://twitter.com/#!/gnpseguros"><img src={ require("../img/twitter-2.png") }/></a></div>
						<div className="social-icon"><a href="http://www.youtube.com/user/GNPviviresincreible"><img src={ require("../img/youtube.png") }/></a></div>
						<div className="social-icon"><a href="https://instagram.com/gnpseguros/"><img src={ require("../img/instagram.png") }/></a></div>
						<div className="social-icon"><a href="https://plus.google.com/109326069322011020380/"><img src={ require("../img/googleplus.png") }/></a></div>
						<div className="social-icon"><a href="http://luliygabo.com/"><img src={ require("../img/portalluli.png") }/></a></div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Footer);



// WEBPACK FOOTER //
// ./src/footer/footer.cmpt.js